import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import type { Invoice } from ".";

const FinanceInvoiceDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation() as any;
  const invoice: Invoice | undefined = state?.invoice;

  return (
    <>
      <div className="main_title">
        <h1>Invoice Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - {" "}
          <button onClick={() => navigate("/finance")}>Finance</button> - Invoice
        </p>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <h2>ERP Invoice</h2>
        </div>
        <div className="gap_p">
          <div className="w_33">
            <h6>Invoice No</h6>
            <p>{invoice?.invoiceNo || '-'}</p>
          </div>
          <div className="w_33">
            <h6>ERP Reference</h6>
            <p>{invoice?.erpRef || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Date</h6>
            <p>{invoice?.date || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Customer</h6>
            <p>{invoice?.customer || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Project</h6>
            <p>{invoice?.project || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Booking</h6>
            <p>{invoice?.bookingId || '-'}</p>
          </div>
          <div className="w_33">
            <h6>Amount</h6>
            <p>{invoice ? invoice.amount.toLocaleString() : '-'}</p>
          </div>
          <div className="w_33">
            <h6>Status</h6>
            <p>{invoice?.status || '-'}</p>
          </div>
        </div>
      </div>

      <div className="cards">
        <div className="table_header">
          <h2>Line Items</h2>
        </div>
        <Box sx={{ p: 2, color: '#64748b' }}>Line items placeholder (ERP)</Box>
      </div>
    </>
  );
};

export default FinanceInvoiceDetailPage;
